import React, { useState, useCallback, useRef, useEffect } from 'react';
import './Table.scss';
function renderData(obj) {
    if (typeof obj == 'object') {
        return React.createElement("div", { className: "json-data-315df5f8" }, JSON.stringify(obj));
    }
    if (typeof obj == 'boolean') {
        return React.createElement("div", { className: "boolean-data-315df5f8" }, obj ? 'true' : 'false');
    }
    if (typeof obj == 'number') {
        return React.createElement("div", { className: "numeric-data-315df5f8" }, '' + obj);
    }
    return obj;
}
const minCellWidth = 200;
const Table = ({ columns, data }) => {
    const [columnWidths, setColumnWidths] = useState(null);
    const tableContainerRef = useRef(null);
    useEffect(() => {
        if (tableContainerRef === null || tableContainerRef === void 0 ? void 0 : tableContainerRef.current) {
            const { width } = tableContainerRef.current.getBoundingClientRect();
            let minWidth = (columns === null || columns === void 0 ? void 0 : columns.length) > 0 ? (width - 10) / columns.length : width - 10;
            if (minWidth < minCellWidth)
                minWidth = minCellWidth;
            setColumnWidths(columns.reduce((acc, column) => (Object.assign(Object.assign({}, acc), { [column.id]: {
                    width: minWidth,
                    minWidth: minWidth
                } })), {}));
        }
    }, [tableContainerRef.current, columns]);
    const handleResize = useCallback((columnId, newWidth) => {
        setColumnWidths(prevWidths => (Object.assign(Object.assign({}, prevWidths), { [columnId]: Object.assign(Object.assign({}, prevWidths[columnId]), { width: newWidth }) })));
    }, []);
    const getTotalWidth = () => {
        if (!columnWidths)
            return '100%';
        return Object.values(columnWidths).reduce((total, { width }) => total + width, 0);
    };
    return React.createElement("div", { className: "resizable-table-container-315df5f8", ref: tableContainerRef }, !columnWidths ? React.createElement(React.Fragment, null, "Loading...") : React.createElement("div", { className: "resizable-table-315df5f8", style: {
            minWidth: getTotalWidth()
        } },
        React.createElement("div", { className: "resizable-table__header-315df5f8" }, columns.map(column => React.createElement("div", { key: column.id, className: "resizable-table__header-cell-315df5f8", style: Object.assign({}, columnWidths[column.id]) },
            column.label,
            React.createElement("div", { className: "resizable-table__resize-handle-315df5f8", onMouseDown: e => {
                    var _a;
                    const startX = e.clientX;
                    const startWidth = (_a = e.target.parentElement) === null || _a === void 0 ? void 0 : _a.offsetWidth;
                    const onMouseMove = (e) => {
                        const diff = e.clientX - startX;
                        handleResize(column.id, Math.max(startWidth + diff, minCellWidth));
                    };
                    const onMouseUp = () => {
                        document.removeEventListener('mousemove', onMouseMove);
                        document.removeEventListener('mouseup', onMouseUp);
                    };
                    document.addEventListener('mousemove', onMouseMove);
                    document.addEventListener('mouseup', onMouseUp);
                } })))),
        React.createElement("div", { className: "resizable-table__body-315df5f8" }, data.map((row, rowIndex) => React.createElement("div", { key: rowIndex, className: "resizable-table__row-315df5f8" }, columns.map(column => React.createElement("div", { key: column.id, className: "resizable-table__cell-315df5f8", style: Object.assign({}, columnWidths[column.id]) }, renderData(row[column.id]))))))));
};
export default Table;
